import React from "react";

import { PartnerBanner } from "../../linkbank/components";

import LinkBankFooterV2 from "./LinkBankFooterV2";
import RelinkBankHeader from "./RelinkBankHeader";
import RelinkBankAccounts from "./RelinkBankAccounts";

const RelinkBank = () => {
  return (
    <div className="outerStack-mobile sm:outerStack">
      <div className="innerStack">
        <RelinkBankHeader />
        <RelinkBankAccounts />
        <PartnerBanner />
        <LinkBankFooterV2 />
      </div>
    </div>
  );
};

export default RelinkBank;